import apiClient from './apiClient';

// ============================================================
// Types — 欄位名對齊後端 JSON tag（camelCase）
// ============================================================

export interface PendingItem {
  modId: string;       // "sc", "d203"
  modName: string;     // "銷售合約", "受訂託工單"
  recordNo: string;    // "P9X01A"
  recordDate: string;  // "2026-04-10"
  creator: string;     // user ID
  status: string;      // "S" or "P"
}

export interface ModuleInfo {
  modId: string;
  displayName: string;
  approvalOnly?: boolean;
}

export interface BatchItem {
  modId: string;
  recordNo: string;
}

export interface BatchRequest {
  items: BatchItem[];
  comment: string;
}

export interface BatchResultItem {
  modId: string;
  recordNo: string;
  success: boolean;
  message: string;
}

export interface BatchResponse {
  results: BatchResultItem[];
  success: number;
  failed: number;
}

export interface PendingListResponse {
  data: PendingItem[];
  total: number;
  page: number;
  size: number;
}

export interface ModulesResponse {
  modules: ModuleInfo[];
}

// ============================================================
// Filters
// ============================================================

export interface BatchApprovalFilter {
  modId: string;
  dateFrom: string;
  dateTo: string;
  page: number;
  size: number;
}

// ============================================================
// API methods
// ============================================================

export const batchApprovalApi = {
  // GET /api/batch-approval/modules
  async getModules(): Promise<ModuleInfo[]> {
    const res = await apiClient.get<ModulesResponse>('/api/batch-approval/modules');
    return res.data.modules || [];
  },

  // GET /api/batch-approval/pending
  async getPending(filter: BatchApprovalFilter): Promise<PendingListResponse> {
    const params: Record<string, string | number> = {
      page: filter.page,
      size: filter.size,
    };
    if (filter.modId) params.mod_id = filter.modId;
    if (filter.dateFrom) params.date_from = filter.dateFrom;
    if (filter.dateTo) params.date_to = filter.dateTo;

    const res = await apiClient.get<PendingListResponse>('/api/batch-approval/pending', { params });
    return res.data;
  },

  // GET /api/batch-approval/approved
  async getApproved(filter: BatchApprovalFilter): Promise<PendingListResponse> {
    const params: Record<string, string | number> = {
      page: filter.page,
      size: filter.size,
    };
    if (filter.modId) params.mod_id = filter.modId;
    if (filter.dateFrom) params.date_from = filter.dateFrom;
    if (filter.dateTo) params.date_to = filter.dateTo;

    const res = await apiClient.get<PendingListResponse>('/api/batch-approval/approved', { params });
    return res.data;
  },

  // POST /api/batch-approval/approve
  async batchApprove(items: BatchItem[], comment: string): Promise<BatchResponse> {
    const res = await apiClient.post<BatchResponse>('/api/batch-approval/approve', {
      items,
      comment,
    } as BatchRequest);
    return res.data;
  },

  // POST /api/batch-approval/reject
  async batchReject(items: BatchItem[], comment: string): Promise<BatchResponse> {
    const res = await apiClient.post<BatchResponse>('/api/batch-approval/reject', {
      items,
      comment,
    } as BatchRequest);
    return res.data;
  },

  // POST /api/batch-approval/writeoff
  async batchWriteoff(items: BatchItem[], comment: string): Promise<BatchResponse> {
    const res = await apiClient.post<BatchResponse>('/api/batch-approval/writeoff', {
      items,
      comment,
    } as BatchRequest);
    return res.data;
  },
};
